import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import { useGetSettingQuery } from '../../../../Redux/Apis/siteApi';

function Logos() {
    const {data :{weblog: {logos : {data}}}} = useGetSettingQuery()

    return ( 
        <div className="logo-carousel-section">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <OwlCarousel className="logo-carousel-inner owl-carousel" loop autoplay margin={30} autoplayTimeout={2000} items={4} responsive={
                        {
                            0:{items:1, nav:false},
                            600:{items:3,nav:false},
                            1000:{items:4,nav:false,loop:true}
                        }}>
                            {data.lsi_logoList && data.lsi_logoList.map((image,index) => 
                                <div className="single-logo-item item" key={index}>
                                    <img src={image} alt=""/>
                                </div>
                            )}
                        </OwlCarousel>
                    </div>
                </div>
            </div>
        </div>
     );
}

export default Logos;